import React, { useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { GlobalContext } from "../Context/GlobalContext";
import {
  Files,
  History,
  Home,
  MessageCircleQuestionMark,
  ScanFace,
  User,
} from "lucide-react";

const Footer = () => {
  const { translatedLabels, is4Life } = useContext(GlobalContext);
  const screenLabels = translatedLabels?.common;
  const location = useLocation();

  const isActive = (paths) => {
    if (Array.isArray(paths)) {
      return paths.includes(location.pathname);
    }
    return location.pathname === paths;
  };

  return (
    <div className="fixed-bottom" style={{ zIndex: 2 }}>
      <div className="footer-part d-flex justify-content-between pt-2 pb-0 text-white">
        <Link
          to={is4Life ? "/dashboard2" : "/dashboard"}
          className={`icon-part text-center text-decoration-none`}
        >
          <div>
            <Home
              size={28}
              className={`${isActive(["/dashboard", "/view-more-details", "/dashboard2"])
                ? "footer-active"
                : "footer-icon"
                }`}
            />
          </div>
          <p
            className={`mb-0 ${isActive(["/dashboard", "/view-more-details", "/dashboard2"])
              ? "footer-active"
              : "footer-inactive"
              }`}
          >
            {screenLabels?.home?.label_value || "Home"}
          </p>
        </Link>
        {!is4Life ? (
          <Link
            to="/documents"
            className={`icon-part text-center text-decoration-none `}
          >
            <div>
              <Files
                size={28}
                className={`${isActive(["/documents", "/upload-document", "/export-document"])
                  ? "footer-active"
                  : "footer-icon"
                  }`}
              />
            </div>
            <p
              className={`mb-0 ${isActive(["/documents", "/upload-document", "/export-document"])
                ? "footer-active"
                : "footer-inactive"
                }`}
            >
              {screenLabels?.documents?.label_value || "Documents"}
            </p>
          </Link>
        )
          : (

            <Link
              to={'/help-guide'}
              className={`icon-part text-center text-decoration-none `}
            >
              <div>
                <MessageCircleQuestionMark
                  size={28}
                  className={`${isActive(["/help-guide"])
                    ? "footer-active"
                    : "footer-icon"
                    }`}
                />
              </div>
              <p
                className={`mb-0 ${isActive(["/help-guide"])
                  ? "footer-active"
                  : "footer-inactive"
                  }`}
              >
                {screenLabels?.faqs?.label_value || "FAQs"}
              </p>
            </Link>

          )}

        <Link
          to="/start-scan"
          className={`icon-part start-scan-btn text-center text-decoration-none ${isActive(["/start-scan"]) ? "text-primary active" : ""
            }`}
        >
          <ScanFace
            className={`scan-icon text-white ${isActive(["/start-scan"]) ? "active" : ""
              }`}
          />
        </Link>

        <Link
          to={is4Life ? "/user-scan-details-four-life" : "/history"}
          className={`icon-part text-center text-decoration-none `}
        >
          <div>
            <History
              size={28}
              className={`${isActive(["/history", "/user-scan-details", "/user-scan-details-four-life"])
                ? "footer-active"
                : "footer-icon"
                }`}
            />
          </div>
          <p
            className={`mb-0 ${isActive(["/history", "/user-scan-details", "/user-scan-details-four-life"])
              ? "footer-active"
              : "footer-inactive"
              }`}
          >

            {screenLabels?.history?.label_value || "History"}
          </p>
        </Link>

        <Link
          to="/profile"
          className={`icon-part text-center text-decoration-none `}
        >
          <div>
            <User
              size={30}
              className={`${isActive([
                "/profile",
                "/profile-update",
                "/change-password",
                "/deleteAcc-one",
                "/language-selection",
                !is4Life ? "/help-guide" : '',
                "/view-questions",
              ])
                ? "footer-active"
                : "footer-icon"
                }`}
            />
          </div>
          <p
            className={`mb-0 ${isActive([
              "/profile",
              "/profile-update",
              "/change-password",
              "/deleteAcc-one",
              "/language-selection",
              !is4Life ? "/help-guide" : '',
              "/view-questions",
            ])
              ? "footer-active"
              : "footer-inactive"
              }`}
          >
            {screenLabels?.profile?.label_value || "Profile"}
          </p>
        </Link>
      </div>
    </div>
  );
};

export default Footer;
